import React, {useEffect, useState} from 'react';
import {Pie} from "@ant-design/plots";
import axios from "axios";
import {API_PATH} from "../../components/const";

const VisitorPie2 = (props) => {
    const [dataObject, setDataObject] = useState({})
    const [data, setData] = useState([])
    const [time, setTime] = useState(new Date());
    const month = ["Янв ","Фев ","Мар ","Апр","Май","Июн","Июл ","Авг","Сен","Окт","Ноя","Дек",]
// Calculate the date one week ago
    const oneWeekAgo = new Date(time);
    oneWeekAgo.setDate(time.getDate() - 7);

// Format the date as a string (optional)
//     const formattedDate = oneWeekAgo.toISOString().split('T')[0];


    const yesterday = new Date(time);

    yesterday.setDate(time.getDate() - 1);

// Format the date as a string (optional)
//         const formattedDate2 = yesterday.toISOString().split('T')[0];
    const getData = () => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analytics/gender/weekly?date_str=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" +  Number(time?.getDate()), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                // console.log(res?.data)
                setDataObject(res?.data)
                setData([{
                    type: "Мужской",
                    value: res?.data?.current_week?.Male
                }, {
                    type: "Женский",
                    value: res?.data?.current_week?.Female
                } ])
            })
    }

    const config = {
        appendPadding: 10,
        data,
        color: ['#5664D2', '#FC53F5', '#00E480', '#FF3542', '#0090EB', '#FFB100', '#4D4F6C'],
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        label: {
            type: 'inner',
            offset: '-50%',
            content: ({percent}) => `${(percent * 100).toFixed(0)}%`,
            style: {
                fontSize: 20,
                textAlign: 'center',
            },
        },
        interactions: [
            {
                type: 'element-active',
            },
        ],
    };
    useEffect(() => {
        getData()
    }, [])
    return (
        <div className="visitor-box-min">
            <div className="visitor-box-item">
                <div>
                    <h4 className="font-family-medium">Еженедельно</h4>
                </div>
                <div>
                    <h2> { month[Number(time.getMonth())] + ", " + time.getFullYear()} </h2>
                </div>
            </div>
            <div className="visitor-box-item">
                <div>
                    <h1 className="font-family-medium">{dataObject?.current_week?.Total}</h1>

                </div>
                <div>
                    <h3>
                        Посетители
                    </h3>
                    <p className={dataObject?.change?.Total?.percentage > 0 ? "up font-family-medium" : "down font-family-medium"}>{Math.floor(dataObject?.change?.Total?.percentage) + " "}
                        {
                            dataObject?.change?.Total?.percentage > 0 ?
                                <>
                                    % рост
                                    <img src="/icon/downa.svg" alt=""/>
                                </>
                                :
                                <>
                                    % спад  <img src="/icon/upa.svg" alt=""/>
                                </>


                        }
                    </p>
                    {/*<p className={dataObject?.change?.Total?.percentage > 0 ? "up font-family-medium" : "down font-family-medium"}>{dataObject?.change?.Total?.percentage + " "}*/}
                    {/*    {*/}
                    {/*        !dataObject?.change?.Total?.percentage ?*/}
                    {/*            <>*/}
                    {/*                % рост*/}
                    {/*                <img src="/icon/downa.svg" alt=""/>*/}
                    {/*            </>*/}
                    {/*            :*/}
                    {/*            <>*/}
                    {/*                % спад  <img src="/icon/upa.svg" alt=""/>*/}
                    {/*            </>*/}


                    {/*    }*/}
                    {/*</p>*/}
                </div>
            </div>
            <div className="visitor-box-pie">
                <Pie {...config} />
            </div>
        </div>

    );
};

export default VisitorPie2;